import { getToken, delToken } from './token';
import env from '../env.json';

export class CancelablePromise extends Promise {

  constructor(executor, onCancel = null) {
      super(executor);
      this._onCancel = onCancel;
  }

  cancel() {
      this._onCancel && this._onCancel();
  }
}

export default function request(path, method = 'GET', params = {}, raw = false) {
  let controller = new AbortController();
  return new CancelablePromise(async (resolve, reject) => {
    let token, url = new URL(env.BASE_URL + path), headers = new Headers({
      'Accept': 'application/json'
    }), body = '';
    try {
      token = await getToken() || '';
    } catch {
      token = '';
    }
    if (token) {
      headers.set('token', token);
    }
    if (raw && params instanceof FormData && method === 'POST') {
      body = params;
    } else if (method === 'GET') {
      headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      if (typeof params.entries !== 'undefined') {
        for (let [k, v] of params.entries()) {
          body += (body === '' ? '' : '&') + encodeURIComponent(k) + '=' + encodeURIComponent(v);
        }
      } else {
        for (let k in params) {
          body += (body === '' ? '' : '&') + encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
        }
      }
      url.search = body;
      body = null;
    } else {
      headers.set('Content-Type', 'application/json');
      body = {};
      if (typeof params.entries !== 'undefined') {
        for (let [k, v] of params.entries()) {
          body[k] = v;
        }
      } else {
        body = params;
      }
      body = JSON.stringify(body);
    }
    fetch(url, {
      method,
      headers,
      body,
      signal: controller.signal
    }).then(response => {
      if (response.url.indexOf('unauth') > -1 || response.status === 411) {
        delToken();
        document.dispatchEvent(new Event('login'));
      }
      return response.json()
    }, e => {
      if (e instanceof DOMException) {
        return;
      }
      delToken();
      document.dispatchEvent(new Event('login'));
    }).then(json => {
      if (json.status === 'error') {
        if (json.errcode == 102) {
          delToken();
          document.dispatchEvent(new Event('login'));
        }
        reject(json.errmsg || '');
      } else {
        resolve(json);
      }
    });
  }, () => {
    controller.abort();
  });
}
